import script from "./vodSearchInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./vodSearchInfo.vue?vue&type=script&lang=ts&setup=true"

import "./vodSearchInfo.vue?vue&type=style&index=0&id=7fdc4494&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdc4494"]])

export default __exports__